import { fecha_actual } from "../hooks/elapsed";
import { formatoTiempo } from "../hooks/elapsed";

export const InteraccionesComponent = ({ inter }) => {
  return (
    <>
      <div className="mb-5 flex items-center gap-3 border-l-4 border-metric-blue-700 pl-4">
        <h2 className="font-manrope text-lg font-bold text-slate-900">
          Interaciones
        </h2>
      </div>
      <div className="mt-2 grid grid-cols-1 gap-6 px-2 sm:grid-cols-1 lg:grid-cols-2">
        {inter &&
          inter.length > 0 &&
          inter.map((c: any) => {
            return (
              <div
                key={c.id}
                className="rounded-xl border border-l-4 border-metric-blue-600 border-slate-100 bg-white p-5 shadow-sm transition-all hover:shadow-md"
              >
                <div className="mb-2 flex items-start justify-between">
                  <span className="text-[10px] font-bold uppercase text-slate-400">
                    {fecha_actual(c.fd_registro)}
                  </span>
                  <button className="text-slate-300 hover:text-slate-500"></button>
                </div>
                <h6 className="m-0 p-0  text-sm font-bold text-slate-800">
                  {c.interaccion_id}
                </h6>
                <h6 className="m-0 p-0 text-sm font-bold text-slate-800">
                  {c.descTipoLlamada}
                </h6>
              </div>
            );
          })}
      </div>
    </>
  );
};
